// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__yOak7","bigColWidth":"Table_bigColWidth___qQyy","biggerColWidth":"Table_biggerColWidth__XA9XH","row":"Table_row__32ydG","col":"Table_col__MvQMI"};